// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__1IOIy","content":"GlobalSearch_content__2doVF"};